import { useMemo } from 'react';
import { parseCtaDirective, readCtaAttributes } from '@/lib/cta';
import { CtaBlock } from './CtaBlock';
import { mdxComponents } from './MDXComponents';
import { useMdxComponent } from '@/hooks/useMdxComponent';
import type { MdxContentComponent } from '@/hooks/useMdxComponent';
import type { HTMLAttributes } from 'react';
import 'katex/dist/katex.min.css';

interface Props {
  content: string;
  context?: { slug?: string; title?: string };
}

interface CtaElementProps extends HTMLAttributes<HTMLElement> {
  headline?: string;
  body?: string;
  actionlabel?: string;
  actiontype?: string;
  intent?: string;
  href?: string;
  email?: string;
  buttonstyle?: string;
}

export const MarkdownContent = ({ content, context }: Props): React.JSX.Element => {
  const processed = useMemo(() => parseCtaDirective(content), [content]);
  const { Component, isEvaluating } = useMdxComponent(processed);

  const components = useMemo(() => ({
    ...mdxComponents,
    'cta-block': (props: CtaElementProps) => {
      const cta = readCtaAttributes({
        headline: props.headline,
        body: props.body,
        actionlabel: props.actionlabel,
        actiontype: props.actiontype,
        intent: props.intent,
        href: props.href,
        email: props.email,
        buttonstyle: props.buttonstyle,
      });
      if (!cta) return <></>;
      return <CtaBlock cta={cta} context={context} />;
    },
  }), [context]);

  if (isEvaluating || !Component) return <></>;

  const MDXContent: MdxContentComponent = Component;
  return <MDXContent components={components as Record<string, unknown>} />;
};
